import { ROUTE } from '../../../routes';
let phoneNumber = '';
export const accountDetails = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => { };
export const contact = async (action, _datastore, { navigate, setDatastore, asyncStorage }) => {
    await navigate(ROUTE.CONTACT_US);
};
export const goBack = async (action, _datastore, { goBack }) => {
    goBack();
};
